/**
 * @desc 亚马逊格式的装箱单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationMaster.exportBoxingAmazon.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/exportBoxingAmazon`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
